import { arrayOrArray } from '@apia/util';
import { Box, Label, Select } from '@apia/theme';
import { observer } from 'mobx-react-lite';
import { QueryController } from './QueryController';

export const FilterTypesComponent = observer(
  ({ queryController }: { queryController: QueryController }) => {
    return (
      <>
        {queryController.conditions.map((f, idx) => {
          const options = arrayOrArray(f.options.option);

          return (
            <Label key={f.name}>
              <Box as="span">{f.text}:</Box>
              <Select
                title={f.title}
                onChange={(ev) => {
                  const selectedValue = ev.target.value;
                  queryController.conditions[idx].value = selectedValue;
                  queryController.setFilterOptions();
                }}
                disabled={f.readonly || f.disabled}
                value={f.value}
              >
                {options.map((option) => {
                  return (
                    <option value={option.value} key={option.value}>
                      {option.content}
                    </option>
                  );
                })}
              </Select>
            </Label>
          );
        })}
      </>
    );
  },
);
